import styled from 'styled-components';

export const UnverifiedTextWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  p,
  .MuiButtonBase-root {
    margin: 0;
  }
`;
